'use client';

import type { ReactNode } from 'react';
import { InlineExecutionToolCard } from '../shared/inline-execution-tool-card';
import { getHITLArtifactHeaderActions } from '../shared/hitl-artifact-header-actions';
import {
  extractMemories,
  renderMemoryListResult,
} from './memory-result-renderer';
import type { CardRenderContext } from '../../tool-config-types';

const isNoMemoryResult = (output: unknown): boolean =>
  extractMemories(output).length === 0;

export const renderMemoryRecallCard = (ctx: CardRenderContext): ReactNode => {
  const isRunning =
    ctx.toolCallData.status === 'started' ||
    ctx.toolCallData.status === 'in-progress';

  const noMemoryResult =
    !isRunning &&
    ctx.toolCallData.status === 'completed' &&
    isNoMemoryResult(ctx.toolCallData.output);

  const displayText = isRunning
    ? ctx.labelPresent
    : noMemoryResult
      ? 'No memories found'
      : ctx.labelPast;

  const content = noMemoryResult
    ? null
    : renderMemoryListResult({
        content: ctx.toolCallData.output,
        input: ctx.toolCallData.input,
        maxHeight: '400px',
        onOpenObject: ctx.onOpenObject,
      });

  return (
    <InlineExecutionToolCard
      title={displayText}
      defaultExpanded={false}
      status={ctx.toolCallData.status}
      error={ctx.toolCallData.error}
      headerActions={getHITLArtifactHeaderActions(ctx)}
      autoCollapseWhenComplete={ctx.autoCollapseWhenComplete}
    >
      {content}
    </InlineExecutionToolCard>
  );
};
